import { css } from '@emotion/css';

import { AI_COLORS } from '../../consts';

export const suggestionsContainerStyles = css`
  background:
    linear-gradient(#fff 0 0) padding-box,
    linear-gradient(
        90deg,
        ${AI_COLORS.lavenderBlue}99 0%,
        ${AI_COLORS.lilacPink}99 67.71%,
        ${AI_COLORS.fuchsiaPink}99 100%
      )
      border-box;
`;
